import Skeleton from "react-loading-skeleton";
import { FormLabel, RichTextEditor } from "../../../components/forms";
import InfoBubble from "../../../components/forms/richtexteditor/InfoBubble";
import { useTooltipContext } from "../contexts/TooltipContext";
import { GridWrapper } from "../../../components";

export const InfoBubbleNotesWrapper = ({
    className,
    label,
    fieldKey,
    defaultValue,
    isLoading = false,
    onChange,
    onBlur,
    ...rest
}) => {
    const { getTooltip } = useTooltipContext();

    const info = fieldKey == null ? null : getTooltip(fieldKey);

    return <div className={className}>
        <div className="d-flex justify-content-between mt-1">
            <FormLabel className={"mt-auto"}>
                {label}
            </FormLabel>
            {<InfoBubble
                iconClassName="mb-1 ms-auto"
                showBubble={info != null}
                info={info}
            />}
        </div>
        {isLoading
            ? <Skeleton containerClassName="row pt-3 px-3" height={100} />
            : <RichTextEditor
                defaultValue={defaultValue}
                onChange={onChange}
                onBlur={onBlur}
                height="100%"
                {...rest}
            />}
    </div>
}

export const InfoBubbleInputWrapper = ({ className = "", iconClassName = "", fieldKey, children, ...rest }) => {
    const { getTooltip } = useTooltipContext();

    const info = fieldKey == null ? null : getTooltip(fieldKey);

    return <GridWrapper
        className={className}
        gridTemplateColumns={"1fr auto"}
    >
        <span className="col-start-1">
            {children}
        </span>
        <InfoBubble
            {...rest}
            className="col-start-2"
            iconClassName={iconClassName}
            showBubble={info != null}
            info={info}
        />
    </GridWrapper>;
};

export const InfoBubbleLabelWrapper = ({ className = "", iconClassName = "", fieldKey, children, ...rest }) => {
    const { getTooltip } = useTooltipContext();

    const info = fieldKey == null ? null : getTooltip(fieldKey)

    return <GridWrapper
        className={className}
        gridTemplateColumns={"auto 1fr"}
    >
        <span className="col-start-1">
            {children}
        </span>
        <InfoBubble
            {...rest}
            className="col-start-2 me-auto"
            iconClassName={iconClassName}
            showBubble={info != null}
            info={info}
        />
    </GridWrapper>
}
